export const tableColumns = [
    'Name',
    'Type',
    'Size'
];
